import { t } from "../../i18n";
import { AlertTriangle, X } from "lucide-react";

export function ConfirmMessageDeleteDialog({
  open,
  busy,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-stone-950/50 p-4"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !busy) onCancel();
      }}
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="delete-message-title"
        aria-describedby="delete-message-description"
        className="w-full max-w-md rounded-2xl border border-stone-200 bg-white p-5 shadow-2xl dark:border-white/10 dark:bg-stone-900"
      >
        <div className="flex items-start gap-3">
          <div className="grid size-10 shrink-0 place-items-center rounded-xl bg-red-50 text-red-600 dark:bg-red-950/40 dark:text-red-300">
            <AlertTriangle size={19} />
          </div>
          <div className="min-w-0 flex-1">
            <h2 id="delete-message-title" className="font-bold">
              {t("Remove this point from the conversation?")}
            </h2>
            <p
              id="delete-message-description"
              className="mt-1 text-sm leading-6 text-stone-500"
            >
              {t(
                "This message and every response after it will be removed from the active path. Preserved alternatives are not erased.",
              )}
            </p>
          </div>
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            aria-label={t("Close")}
          >
            <X size={18} />
          </button>
        </div>
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            className="button px-4 py-2 text-sm"
            disabled={busy}
            onClick={onCancel}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            autoFocus
            disabled={busy}
            onClick={onConfirm}
            className="rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-50"
          >
            {busy ? "Removing…" : "Remove messages"}
          </button>
        </div>
      </div>
    </div>
  );
}
